import { useGetOne } from 'react-admin';

export const AUDIT_LOGS_QUERY = 'audit-logs';

export function useClaimAuditLogV2(claimId) {
  return useGetOne('claims', { id: `${claimId}/audit-log` }, { enabled: !!claimId });
}
